/* eslint-disable camelcase */
import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

const moduleSelector = '.hero-section .splide';

const getMediaSrc = (media) => media?.url ?? (typeof media === 'string' ? media : '');

const isVideoMedia = (media) => {
  if (media?.type === 'video') return true;
  const mime = media?.mimeType || media?.mime;
  if (mime && String(mime).startsWith('video/')) return true;
  const src = getMediaSrc(media);
  return /\.(mp4|webm|ogg|mov)(\?|#|$)/i.test(src);
};

const buildBackgroundMedia = (background) => {
  const src = getMediaSrc(background);
  if (!src) return '';

  if (isVideoMedia(background)) {
    return /* html */ `<video src="${src}" autoplay muted loop playsinline aria-hidden="true" role="presentation"></video>`;
  }

  return /* html */ `<img src="${src}" alt="" aria-hidden="true" role="presentation">`;
};

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    const sliderList = query.querySelector('.splide__list');
    try {
      sliderList.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(sliderList.data);

      data.forEach((item) => {
        const {
          background, title, text, button_link, button_text, position,
        } = item;
        const hasContent = (title && title.trim()) || (text && text.trim())
          || (button_text && button_text.trim() && button_link && button_link.trim());
        const slideClasses = ['hero-section__slide', hasContent ? 'hero-section__slide--overlay' : ''].filter(Boolean).join(' ');
        const slide = document.createElement('div');
        slide.className = 'splide__slide';
        slide.innerHTML = /* html */ `
          <div class="${slideClasses}">
            ${buildBackgroundMedia(background)}
            <div class="container" data-side="${position}">
              <div class="hero-section__slide__content">
                ${title && title.trim() ? `<h3 class="hero-section__slide__title">${title}</h3>` : ''}
                ${text && text.trim() ? `<p class="hero-section__slide__text">${text}</p>` : ''}
                ${button_text && button_text.trim() && button_link && button_link.trim() ? `<a class="btn-custom primary" href="${button_link}">${button_text}</a>` : ''}
              </div>
            </div>
          </div>
        `;
        sliderList.appendChild(slide);
      });

      // Count the number of slides
      const slideCount = sliderList.querySelectorAll('.splide__slide').length;

      const slider = new Splide(query, {
        type: 'fade',
        rewind: true,
        perPage: 1,
        perMove: 1,
        pagination: slideCount > 1,
        drag: slideCount > 1,
        arrows: false,
        autoplay: slideCount > 1,
        interval: 4000,
        pauseOnHover: true,
        speed: 1000,
        height: '75vh',

      });
      const slides = sliderList.querySelectorAll('.splide__slide');

      const syncVideos = (activeIndex) => {
        slides.forEach((slideEl, index) => {
          const video = slideEl.querySelector('video');
          if (!video) return;
          if (index === activeIndex) {
            video.currentTime = 0;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      };

      slider.on('active', (slide) => syncVideos(slide.index));
      slider.on('mounted', () => syncVideos(slider.index));

      slider.mount();
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
